import React from "react";
import {
  Dimensions,
  Platform,
  View,
  Text,
  TouchableOpacity,
} from "react-native";
import { string, bool } from "prop-types";

import { Emoji, Picker, emojiIndex } from "emoji-mart";
import EmojiHelper from "./EmojiHelper";
import Configuration from "../config/configuration";

require("./emoji-style.css");

var $ = require("jquery");
EmojiHelper.init(emojiIndex.emojis);

const emojiURL = new Configuration().API_URL + "/emoji?";

//based on InlineSVG, modified to support actions

function startsWith(str, substring) {
  return str.indexOf(substring) === 0;
}

function serializeAttrs(map) {
  const ret = {};
  for (let prop, i = 0; i < map.length; i++) {
    const key = map[i].name;
    if (key === "class") {
      prop = "className";
    } else if (!startsWith(key, "data-")) {
      prop = convertReactSVGDOMProperty(key);
    } else {
      prop = key;
    }

    ret[prop] = map[i].value;
  }
  return ret;
}

function getSVGFromSource(src) {
  document.execCommand("enableObjectResizing", false, false);
  const svgContainer = document.createElement("div");
  svgContainer.innerHTML = src;
  const svg = svgContainer.firstElementChild;
  svg.remove ? svg.remove() : svgContainer.removeChild(svg);
  return svg;
}

function extractSVGProps(src) {
  const map = getSVGFromSource(src).attributes;
  return map.length > 0 ? serializeAttrs(map) : null;
}

export default class WebSVG extends React.Component {
  constructor(props) {
    super(props);
    this.id = this.props.id;
    this.onAction = this.props.onAction;
    this.onFocus = this.props.onFocus;
    this.changePage = this.props.changePage;
    this.onPress = this.props.onPress;
    this.outputVariables = this.props.outputVariables;
    this.variables = this.props.variables;
    this.elements_dy = this.props.elements_dy;

    const uuidv4 = require("uuid/v4");
    this.svgId = uuidv4();

    this.scrollEvents =
      this.props.scrollEvents != null ? this.props.scrollEvents : {};
    this.scrollFactor = null;
    this.scrollWidth = null;
    this.scrollHeight = null;

    this.relativeElements = {};

    this.renderScreen = "svg";
    this.emojiPickerId = null;
    this.emojiField = null;

    const that = this;
    if (window.onmessage == null) {
      window.addEventListener("message", (event) => {
        if (
          event.data.toString().startsWith("click") &&
          that.props.uri != null &&
          that.onPress != null
        ) {
          const id = event.data.substring(6);
          if (that.svgId === id) {
            that.onPress();
          }
        }
      });
    }
  }

  componentDidMount() {
    this.setActions();
    this.scrollEvents[this.id] = this.updateFloatingObjects.bind(this);

    this.hideSpinner();
    this.startTimer();
  }

  componentDidUpdate() {
    //console.log("Card updated");
    this.setActions();
    this.scrollEvents[this.id] = this.updateFloatingObjects.bind(this);
    this.updateFloatingObjects(null, null, 0, 0);
    this.hideSpinner();
  }

  hideSpinner() {
    const spinnerEl = $("#spinner_wait");
    if (spinnerEl != null) {
      if (spinnerEl[0] != null) spinnerEl[0].setAttribute("display", "none");
    }
  }

  startTimer() {
    const variables = this.outputVariables;
    function onTimerActivity() {
      var timerActivity = document.getElementById("timer_activity_now");
      var timerStart = document.getElementById("timer_activity_start");
      var timerDuration = document.getElementById("timer_activity_duration");
      var now = new Date();
      if (timerActivity != null) {
        timerActivity.value = now.toISOString();
        if (variables != null)
          variables["timer_activity_now"] = timerActivity.value;
      }
      if (
        timerActivity != null &&
        timerStart != null &&
        timerStart.value != null &&
        timerStart.value.length > 0
      ) {
        var diff = (now - Date.parse(timerStart.value)) / 1000;
        var hh = parseInt(diff / 3600, 10);
        var min = parseInt(diff / 60, 10);
        var sec = parseInt(diff % 60, 10);
        timerDuration.value =
          (hh < 10 ? "0" : "") +
          hh +
          ":" +
          (min < 10 ? "0" : "") +
          min +
          ":" +
          (sec < 10 ? "0" : "") +
          sec;
        variables["timer_activity_duration"] = timerDuration.value;
      }
      window.setTimeout(onTimerActivity, 1000);
    }

    var timerActivity = document.getElementById("timer_activity_now");
    if (timerActivity != null && window.onTimerActivity == null) {
      window.onTimerActivity = onTimerActivity;
      window.setTimeout(onTimerActivity, 1000);
    }
  }

  updateFloatingObjects(scrollWidth, scrollHeight, scrollX, scrollY) {
    //let {width, height} = Dimensions.get('window');
    if (scrollWidth != null) this.scrollWidth = scrollWidth;
    if (scrollHeight != null) this.scrollHeight = scrollHeight;

    const that = this;
    Object.keys(this.relativeElements).forEach((key) => {
      if (that.scrollWidth != null && that.scrollHeight != null) {
        const target = this.relativeElements[key];
        try {
          that.translateObject(target, scrollX, scrollY);
        } catch (e) {
          console.log(e);
        }
      }
    });
  }

  translateObject(target, scrollX, scrollY) {
    const obj = target[0];

    if (this.scrollFactor == null) {
      //TODO: replace hack with a nicer calculation if possible
      obj.setAttribute("opacity", "0");
      obj.setAttribute("transform", "translate(0 0)");
      const pos1 = obj.getBoundingClientRect();
      obj.setAttribute("transform", "translate(1 1)");
      const pos2 = obj.getBoundingClientRect();

      this.scrollFactor = { x: pos2.x - pos1.x, y: pos2.y - pos1.y };
      //console.log(this.scrollFactor);
    }
    const factorX = 1.0 / this.scrollFactor.x;
    const factorY = 1.0 / this.scrollFactor.y;

    const dx = obj.attributes.getNamedItem("dx").value;
    const dy = obj.attributes.getNamedItem("dy").value;
    const x =
      dx >= 0
        ? dx * 1 + scrollX * factorX
        : (scrollX * 1 + this.scrollWidth * 1) * factorX + dx * 1;
    const y =
      dy >= 0
        ? dy * 1 + scrollY * factorY
        : (scrollY * 1 + this.scrollHeight * 1) * factorY + dy * 1;
    if (x != null && y != null) {
      obj.setAttribute("transform", "translate(" + x + " " + y + ")");
      obj.setAttribute("opacity", "1");
    }
  }

  setActions() {
    const onAction = this.onAction;
    const onFocus = this.onFocus;
    const that = this;

    if (this.emojiPickerId != null) {
      const btnPicker = document.getElementById(this.emojiPickerId);
      if (btnPicker != null) {
        btnPicker.onclick = function () {
          console.log("Switch to emoji picker");
          that.renderScreen = "emoji-picker";
          that.forceUpdate();
        };
      }
    }

    $.each($("g"), function () {
      var id = $(this)[0].id;
      if (id != null && id.length > 0 && that.elements_dy != null) {
        const offset = $(this).offset();
        if (offset != null && offset.top != null) {
          that.elements_dy[id] = offset.top;
        }
      }

      if (id != null && id.length > 0) {
        const gclass = $(this)[0].className;
        if (gclass != null && gclass.baseVal === "g-float") {
          that.relativeElements[id] = $(this);
        }
      }

      var attr = $(this)[0].attributes.getNamedItem("onaction");
      if (attr != null) {
        $(this).click(function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          var attr = e.currentTarget.attributes.getNamedItem("onaction");
          if (attr != null) {
            that.showSpinner();

            var gtransition = e.currentTarget.attributes.getNamedItem(
              "gtransition",
            );
            const transitionEl =
              gtransition != null ? $("#" + gtransition.value) : null;
            if (transitionEl != null) {
              const pos = e.currentTarget.getBoundingClientRect();
              const dx = 0;
              const dy = 0;
              //transitionEl[0].setAttribute("transform", "translate(" + dx + " " + dy + ")");
              const el = transitionEl[0];
              if (el != null) {
                el.setAttribute("display", "inline");
              }
            } else {
              var a = document.createAttribute("fill");
              a.value = "red";
              e.currentTarget.attributes.setNamedItem(a);
            }
            onAction(attr.value);
          }
          return false;
        });
      }
    });

    var variables = this.outputVariables;
    var enableFocus = this.enableFocus;
    const onModifiedInput = this.onModifiedInput;
    $.each($("input"), function () {
      onModifiedInput($(this), variables, onAction, onFocus, enableFocus);
      $(this).click(function (e) {
        const el = e.currentTarget;
        try {
          el.setSelectionRange(0, el.value.length);
        } catch (e) {
          el.select();
        }
      });
    });
    $.each($("textarea"), function () {
      onModifiedInput($(this), variables, onAction, onFocus, enableFocus);
      $(this).keyup(function (e) {
        if (e.ctrlKey && e.keyCode == 13) {
          e.preventDefault();
          e.stopImmediatePropagation();
          var attr = e.currentTarget.attributes.getNamedItem("onctrlenter");
          if (attr != null) {
            const val = e.currentTarget.value;
            if (variables != null && name != null) {
              variables[name] = val;
            }
            var data = attr.value.replace(new RegExp("{value}", "g"), val);
            onAction(data);
          }
        }
      });
    });
    $.each($("select"), function () {
      onModifiedInput($(this), variables, onAction, onFocus, enableFocus);
    });
    $.each($("p"), function () {
      var attr = $(this)[0].attributes.getNamedItem("contenteditable");
      if (attr != null && !!attr.value) {
        onModifiedInput($(this), variables, onAction, onFocus, enableFocus);
      }
    });
  }

  showSpinner() {
    const spinnerEl = $("#spinner_wait");
    if (spinnerEl != null && spinnerEl[0] != null) {
      spinnerEl[0].setAttribute("display", "inline");
    }
  }

  onModifiedInput(that, variables, onAction, onFocus, enableFocus) {
    if (variables == null) {
      return;
    }

    var input = that[0];
    const name =
      input.name != null && input.name.length > 0 ? input.name : input.id;
    const val =
      input.tagName.toLowerCase() === "p"
        ? input.innerText
        : input.type === "checkbox"
        ? input.checked
        : input.value;
    if (name != null && variables[name] == null) {
      variables[name] = val;
    } else if (name != null) {
      if (input.type === "checkbox") input.checked = variables[name];
      else if (input.tagName.toLowerCase() === "p")
        input.innerText = variables[name];
      else input.value = variables[name];
    }
    //console.log(name); console.log(val);

    if (input.tabIndex < 0) {
      //&& enableFocus
      input.focus();
      if (input.value != null) {
        var value = input.value;
        input.value = "";
        input.value = value; //go to end
      }
    }

    const evt = input.type === "select" ? "change" : "input";
    that.on(evt, function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      const val =
        input.tagName.toLowerCase() === "p"
          ? input.innerText
          : input.type === "checkbox"
          ? input.checked
          : input.value;
      if (variables != null && name != null) {
        variables[name] = val;
      }

      var attr = e.currentTarget.attributes.getNamedItem("onaction");
      if (attr != null) {
        var data = attr.value.replace(new RegExp("{value}", "g"), val);
        onAction(data);
      }
      return false;
    });

    that.on("focus", function (e) {
      if (onFocus != null) {
        const fdata = {
          card: this.variables.card_type,
          card_id: this.id,
          name: name,
          pos: input.getBoundingClientRect(),
        };
        onFocus(fdata);
      }
      return false;
    });
  }

  handleEmojiPicker(svgSource, card) {
    var idx = svgSource.indexOf("{react:emoji_picker");
    if (idx >= 0) {
      //TODO: support mutliple pickers if we ever need it, code is written to support only one
      var idxEnd = svgSource.indexOf("}", idx);
      const pickerCode = svgSource.substring(idx + 1, idxEnd); //ugly string parsing, to replace at a later date
      const arrCode = pickerCode.split(" ");

      card.emojiField = arrCode[1];
      const selectedValue =
        card.outputVariables[card.emojiField] != null
          ? card.outputVariables[card.emojiField]
          : arrCode[2];

      const sym =
        selectedValue == null ||
        selectedValue.includes("{") ||
        selectedValue.trim().length === 0
          ? "2754"
          : selectedValue;
      //const codesArray = []; sym.forEach(el => codesArray.push('0x' + el)); const selectedEmoji = String.fromCodePoint(...codesArray);
      const selectedEmoji = EmojiHelper.lookup(sym);
      this.emojiPickerId = "btn-emoji-picker-" + this.id;
      const pickerId = this.emojiPickerId;
      const url = emojiURL + sym.toLowerCase();
      const emoji =
        `<div id='` +
        pickerId +
        `' class='emojiPickerButton'>
                    <svg width="18" height="18" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 36 36">
                        <image xlink:href='` +
        url +
        `' width="36" height="36"/>
                    </svg>
                </div>`;
      //console.log(emoji);
      return (
        svgSource.substring(0, idx) + emoji + svgSource.substring(idxEnd + 1)
      );
    } else {
      return svgSource;
    }
  }

  selectEmoji(e) {
    this.outputVariables[this.emojiField] = e.unified;
    this.renderScreen = "svg";
    this.forceUpdate();
    this.setActions();
  }

  cancelEmoji() {
    this.renderScreen = "svg";
    this.forceUpdate();
    this.setActions();
  }

  render() {
    if (this.renderScreen === "svg") {
      return this.renderSvg();
    } else if (this.renderScreen === "emoji-picker") {
      //TODO: definitely move from here, make it nicer. lowest hanging fruit for now
      const selectEmoji = this.selectEmoji.bind(this);
      const cancelEmoji = this.cancelEmoji.bind(this);
      return (
        <View style={{ alignItems: "center", flex: 1 }}>
          <Picker
            set="twitter"
            showSkinTones={false}
            autoFocus={true}
            onSelect={selectEmoji}
          />
          <Text> </Text>
          <TouchableOpacity
            onPress={cancelEmoji}
            style={{ borderColor: "#0DAB76", backgroundColor: "white" }}
          >
            <Text
              style={{
                textAlign: "center",
                fontSize: 18,
                color: "#0DAB76",
                backgroundColor: "white",
              }}
            >
              BACK
            </Text>
          </TouchableOpacity>
        </View>
      );
    }
  }

  renderSvg() {
    let Element, __html, svgProps;
    const { element, raw, src, uri } = this.props;
    const code =
      src != null && src.trim().length > 0
        ? src
        : "<embed name='" + this.svgId + "' src='" + uri + "' />";

    if (raw === true) {
      Element = "svg";
      svgProps = extractSVGProps(code);
      __html = getSVGFromSource(code).innerHTML.replace(
        "<svg ",
        "<svg id='" + this.svgId + "' ",
      );
    }

    const html = __html || code;
    __html = this.handleEmojiPicker(html, this);

    Element = Element || element;
    svgProps = svgProps || {};

    return (
      <Element
        {...svgProps}
        src={null}
        children={null}
        dangerouslySetInnerHTML={{ __html }}
      />
    );
  }
}

WebSVG.defaultProps = {
  element: "span",
  raw: false,
  src: "",
};

WebSVG.propTypes = {
  src: string.isRequired,
  element: string,
  raw: bool,
};
